import { render, staticRenderFns } from "./ConfirmationPurchase.vue?vue&type=template&id=d5e47f7a&scoped=true&"
import script from "./ConfirmationPurchase.vue?vue&type=script&lang=js&"
export * from "./ConfirmationPurchase.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationPurchase.vue?vue&type=style&index=0&id=d5e47f7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e47f7a",
  null
  
)

export default component.exports